import React, { useState, useEffect, memo } from "react";
import Icon from "../../assets/icons/Icon";

const DisplayOrder = ({ initialValue, onConfirm, canEdit = true }) => {
  const [inputValue, setInputValue] = useState(initialValue);

  useEffect(() => {
    setInputValue(initialValue);
  }, [initialValue]);

  const handleInputChange = (e) => {
    if (!canEdit) return;

    setInputValue(e.target.value);
  };

  const handleConfirm = () => {
    if (!canEdit) return;

    onConfirm(inputValue);
  };

  return (
    <div
      className={`input_box ${!canEdit ? "disabled-area" : ""}`}
      style={{
        pointerEvents: canEdit ? "auto" : "none",
        opacity: canEdit ? 1 : 0.6,
      }}
    >
      <input
        className="form-control"
        type="number"
        value={inputValue}
        onChange={handleInputChange}
        id="example-text-input"
        disabled={!canEdit}
        onBlur={() => {
          if (!inputValue) {
            setInputValue(initialValue);
          }
        }}
        autoComplete="off"
        onWheel={(e) => e.target.blur()}
      />

      <div
        className="action-btn"
        onMouseDown={(e) => e.preventDefault()}
        onClick={handleConfirm}
      >
        <Icon name="Check" className="icon_button" />
      </div>
    </div>
  );
};

export default memo(DisplayOrder);
